export default "__VITE_ASSET__Bqx0O7T2__"